if(!customElements.get('facet-filters-form')){
    class FacetFiltersForm extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.sortingSelectWrapper = this.querySelector('.sorting-select-wrapper');

            this.btnSortingOptionSelector = this.sortingSelectWrapper.querySelector('.btn-selected');
            this.btnSortingOptionSelector.addEventListener('click', this.openSortingOption.bind(this));
            this.btnSortingOptionSelector.addEventListener('focusout', this.closeSortingOption.bind(this));
            document.addEventListener('click', (event) => {
                if(!event.target.classList.contains('sorting-select-wrapper') && event.target.closest('.sorting-select-wrapper') == null){
                    this.closeSortingOption(event);
                }
            })

            this.inputSorting = this.sortingSelectWrapper.querySelector('#SortBy');

            this.btnSortingOptionSelector.querySelectorAll('.sorting-select-options li').forEach(item => {
                item.addEventListener('click', e => {
                    this.clickSortingOption(e);
                })
                item.addEventListener('keydown', this.optionKeydownEventHandler.bind(this));
            })

            this.categorySelectWrapper = this.querySelector('.category-select-wrapper');
            if(this.categorySelectWrapper){
                this.initCategorySelect();
            }

            this.prefectureSelectWrapper = this.querySelector('.prefecture-select-wrapper');
            if(this.prefectureSelectWrapper){
                this.initPrefectureSelect();
            }

            this.priceRangeSlider = this.querySelector('.price-range-slider');
            if(this.priceRangeSlider){
                this.initPriceRangeSlider();
            }

            this.form = this.querySelector('#FacetForm');
            this.inputs = this.form.querySelectorAll('input');

            // add facets filter sidebar inputs to this.inputs
            this.sidebarFilter = document.querySelector('sidebar-filter');
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

            if(this.dataset.content == 'collection'){ // collection

                this.productList = this.closest('custom-collection-product-list');
                this.facetRemoveWrapper = this.productList.querySelector('.collection-product-list__active-tags');
                this.products = this.productList.querySelector('#collection-product-list__products');
                this.totalNumberOfProducts = this.productList.querySelector('.collection-product-list__total-number');
                this.productsWrapper = this.productList.querySelector('.collection-product-list__products-wrapper');
                this.facetWrapper = this.closest('.collection-facet-wrapper');

            }else if(this.dataset.content == 'search'){ // search

                this.productList = this.closest('custom-search-product-list');
                this.facetRemoveWrapper = this.productList.querySelector('.search-product-list__active-tags');
                this.products = this.productList.querySelector('#search-item-list__items');
                this.totalNumberOfProducts = this.productList.querySelector('.search-product-list__total-number');
                this.productsWrapper = this.productList.querySelector('.search-item-list__items-wrapper');
                this.facetWrapper = this.closest('.search-facet-wrapper');

            }

            this.btnColumnSwitch = this.productList.querySelector('.product-view-switch-wrapper');
            this.btnLoadMore = this.productList.querySelector('.btn-load-more');
            this.btnFilter = this.querySelector('.product-filter-button');
            this.btnFilter.addEventListener('click', this.openSidebarFilter.bind(this));
            this.btnFilter.addEventListener('keydown', (event) => {
                if(event.key === "Enter"){
                    this.openSidebarFilter();
                }
            })
        }

        refresh(){
            this.init();
        }

        openSidebarFilter(){
            this.sidebarFilter.openSidebarFilter();
        }

        openSortingOption(e){
            e.preventDefault();

            if(e.target.nodeName !== 'LI' && e.target.closest('li') == null){
                e.currentTarget.querySelector('.sorting-select-options').setAttribute('data-hidden', 'false');

                const options = this.btnSortingOptionSelector.querySelectorAll('.sorting-select-options li');
                let index = 0;

                options.forEach(item => {
                    item.setAttribute('tabindex', '0');
                });

                const focusElem = setInterval(() => {
                    const firstOption = options[0];
                    firstOption.focus();
                    var focusedElement = document.activeElement;

                    index++;
                    if(focusedElement === firstOption || index > 5){
                        clearInterval(focusElem);
                    }
                }, 100);
            }
        }

        optionKeydownEventHandler(event){
            const options = this.btnSortingOptionSelector.querySelectorAll('.sorting-select-options li');
            if(event.key === 'ArrowDown'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                        focusableElements[nextIndex].focus();
                    }else{
                        event.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }else if(event.key === 'ArrowUp'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex === 0 ? 0 : currentIndex - 1;
                    focusableElements[nextIndex].focus();
                }
            }else if(event.key === 'Escape'){
                event.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
                options.forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }else if(event.key === 'Enter'){
                this.clickSortingOption(event);
            }else if(event.key === 'Tab'){
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                    }else{
                        event.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }
        }

        closeSortingOption(e){
            if(e.relatedTarget == null || (e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON')){
                e.currentTarget.querySelector('.sorting-select-options').setAttribute('data-hidden', 'true');
                e.currentTarget.querySelectorAll('.sorting-select-options li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }
        }

        resetCategorySelection(){
            if(!this.categorySelectWrapper) return;
            this.inputCategory.setAttribute('value', '');
            this.inputCategory.value = '';
            const label = this.btnCategoryOptionSelector.querySelector('.category-by');
            if(label) label.innerHTML = '蔵元で探す';
            this.categorySelectWrapper.querySelectorAll('.category-select-options li').forEach((li, idx) => {
                li.setAttribute('data-active', idx === 0 ? 'true' : 'false');
            });
        }

        resetPrefectureSelection(){
            if(!this.prefectureSelectWrapper) return;
            this.inputPrefecture.setAttribute('value', '');
            this.inputPrefecture.value = '';
            const label = this.btnPrefectureOptionSelector.querySelector('.prefecture-by');
            if(label) label.innerHTML = '都道府県で探す';
            this.prefectureSelectWrapper.querySelectorAll('.prefecture-select-options li').forEach((li, idx) => {
                li.setAttribute('data-active', idx === 0 ? 'true' : 'false');
            });
        }

        clickSortingOption(e){
            e.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
            this.btnSortingOptionSelector.querySelector('.sort-by').innerHTML = `${e.currentTarget.dataset.option}`;

            this.inputSorting.setAttribute('value', `${e.currentTarget.dataset.optionValue}` );
            this.inputSorting.value = `${e.currentTarget.dataset.optionValue}`;

            if(e.currentTarget.closest('.sorting-select-options')){
                e.currentTarget.closest('.sorting-select-options').querySelectorAll('li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }

            this.submitForm();
        }

        initCategorySelect(){
            this.btnCategoryOptionSelector = this.categorySelectWrapper.querySelector('.btn-selected');
            this.btnCategoryOptionSelector.addEventListener('click', this.openCategoryOption.bind(this));
            this.btnCategoryOptionSelector.addEventListener('focusout', this.closeCategoryOption.bind(this));

            this.inputCategory = this.categorySelectWrapper.querySelector('#CategoryFilter');

            this.btnCategoryOptionSelector.querySelectorAll('.category-select-options li').forEach(item => {
                item.addEventListener('click', e => {
                    this.clickCategoryOption(e);
                })
                item.addEventListener('keydown', this.categoryOptionKeydownEventHandler.bind(this));
            })

            this.categorySelectWrapper.addEventListener('mouseleave', () => {
                this.categorySelectWrapper.querySelector('.category-select-options').setAttribute('data-hidden', 'true');
                this.categorySelectWrapper.querySelectorAll('.category-select-options li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            })
        }

        openCategoryOption(e){
            e.preventDefault();

            if(e.target.nodeName !== 'LI' && e.target.closest('li') == null){
                e.currentTarget.querySelector('.category-select-options').setAttribute('data-hidden', 'false');

                const options = this.btnCategoryOptionSelector.querySelectorAll('.category-select-options li');
                let index = 0;

                options.forEach(item => {
                    item.setAttribute('tabindex', '0');
                });

                const focusElem = setInterval(() => {
                    const firstOption = options[0];
                    firstOption.focus();
                    var focusedElement = document.activeElement;

                    index++;
                    if(focusedElement === firstOption || index > 5){
                        clearInterval(focusElem);
                    }
                }, 100);
            }
        }

        categoryOptionKeydownEventHandler(event){
            const options = this.btnCategoryOptionSelector.querySelectorAll('.category-select-options li');
            if(event.key === 'ArrowDown'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                        focusableElements[nextIndex].focus();
                    }else{
                        event.currentTarget.closest('.category-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }else if(event.key === 'ArrowUp'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex === 0 ? 0 : currentIndex - 1;
                    focusableElements[nextIndex].focus();
                }
            }else if(event.key === 'Escape'){
                event.currentTarget.closest('.category-select-options').setAttribute('data-hidden', 'true');
                options.forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }else if(event.key === 'Enter'){
                this.clickCategoryOption(event);
            }else if(event.key === 'Tab'){
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                    }else{
                        event.currentTarget.closest('.category-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }
        }

        closeCategoryOption(e){
            if(e.relatedTarget == null || (e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON')){
                e.currentTarget.querySelector('.category-select-options').setAttribute('data-hidden', 'true');
                e.currentTarget.querySelectorAll('.category-select-options li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }
        }

        clickCategoryOption(e){
            e.currentTarget.closest('.category-select-options').setAttribute('data-hidden', 'true');
            this.btnCategoryOptionSelector.querySelector('.category-by').innerHTML = `${e.currentTarget.dataset.option}`;

            this.inputCategory.setAttribute('value', `${e.currentTarget.dataset.optionValue}`);
            this.inputCategory.value = `${e.currentTarget.dataset.optionValue}`;

            // 蔵元と都道府県は同時に選択できない（並び替え・価格との組み合わせは可）
            if(e.currentTarget.dataset.optionValue !== ''){
                this.resetPrefectureSelection();
            }

            this.btnCategoryOptionSelector.querySelectorAll('.category-select-options li').forEach(item => {
                item.setAttribute('tabindex', '-1');
                item.setAttribute('data-active', item === e.currentTarget ? 'true' : 'false');
            })

            this.submitForm();
        }

        initPrefectureSelect(){
            this.btnPrefectureOptionSelector = this.prefectureSelectWrapper.querySelector('.btn-selected');
            this.btnPrefectureOptionSelector.addEventListener('click', this.openPrefectureOption.bind(this));
            this.btnPrefectureOptionSelector.addEventListener('focusout', this.closePrefectureOption.bind(this));

            this.inputPrefecture = this.prefectureSelectWrapper.querySelector('#PrefectureFilter');

            this.btnPrefectureOptionSelector.querySelectorAll('.prefecture-select-options li').forEach(item => {
                item.addEventListener('click', e => {
                    this.clickPrefectureOption(e);
                })
                item.addEventListener('keydown', this.prefectureOptionKeydownEventHandler.bind(this));
            })

            this.prefectureSelectWrapper.addEventListener('mouseleave', () => {
                this.prefectureSelectWrapper.querySelector('.prefecture-select-options').setAttribute('data-hidden', 'true');
                this.prefectureSelectWrapper.querySelectorAll('.prefecture-select-options li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            })
        }

        openPrefectureOption(e){
            e.preventDefault();

            if(e.target.nodeName !== 'LI' && e.target.closest('li') == null){
                e.currentTarget.querySelector('.prefecture-select-options').setAttribute('data-hidden', 'false');

                const options = this.btnPrefectureOptionSelector.querySelectorAll('.prefecture-select-options li');
                let index = 0;

                options.forEach(item => {
                    item.setAttribute('tabindex', '0');
                });

                const focusElem = setInterval(() => {
                    const firstOption = options[0];
                    firstOption.focus();
                    var focusedElement = document.activeElement;

                    index++;
                    if(focusedElement === firstOption || index > 5){
                        clearInterval(focusElem);
                    }
                }, 100);
            }
        }

        prefectureOptionKeydownEventHandler(event){
            const options = this.btnPrefectureOptionSelector.querySelectorAll('.prefecture-select-options li');
            if(event.key === 'ArrowDown'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                        focusableElements[nextIndex].focus();
                    }else{
                        event.currentTarget.closest('.prefecture-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }else if(event.key === 'ArrowUp'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex === 0 ? 0 : currentIndex - 1;
                    focusableElements[nextIndex].focus();
                }
            }else if(event.key === 'Escape'){
                event.currentTarget.closest('.prefecture-select-options').setAttribute('data-hidden', 'true');
                options.forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }else if(event.key === 'Enter'){
                this.clickPrefectureOption(event);
            }else if(event.key === 'Tab'){
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                    }else{
                        event.currentTarget.closest('.prefecture-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }
        }

        closePrefectureOption(e){
            if(e.relatedTarget == null || (e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON')){
                e.currentTarget.querySelector('.prefecture-select-options').setAttribute('data-hidden', 'true');
                e.currentTarget.querySelectorAll('.prefecture-select-options li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }
        }

        clickPrefectureOption(e){
            e.currentTarget.closest('.prefecture-select-options').setAttribute('data-hidden', 'true');
            this.btnPrefectureOptionSelector.querySelector('.prefecture-by').innerHTML = `${e.currentTarget.dataset.option}`;

            this.inputPrefecture.setAttribute('value', `${e.currentTarget.dataset.optionValue}`);
            this.inputPrefecture.value = `${e.currentTarget.dataset.optionValue}`;

            // 蔵元と都道府県は同時に選択できない（並び替え・価格との組み合わせは可）
            if(e.currentTarget.dataset.optionValue !== ''){
                this.resetCategorySelection();
            }

            this.btnPrefectureOptionSelector.querySelectorAll('.prefecture-select-options li').forEach(item => {
                item.setAttribute('tabindex', '-1');
                item.setAttribute('data-active', item === e.currentTarget ? 'true' : 'false');
            })

            this.submitForm();
        }

        initPriceRangeSlider(){
            this.priceRangeMax = Number(this.priceRangeSlider.dataset.max) || 0;
            this.priceMinRangeInput = this.priceRangeSlider.querySelector('.price-range-slider__range-input--min');
            this.priceMaxRangeInput = this.priceRangeSlider.querySelector('.price-range-slider__range-input--max');
            this.priceMinNumberInput = this.priceRangeSlider.querySelector('.price-range-slider__number--min');
            this.priceMaxNumberInput = this.priceRangeSlider.querySelector('.price-range-slider__number--max');
            this.priceRangeTrack = this.priceRangeSlider.querySelector('.price-range-slider__range');

            this.updatePriceRangeTrack();

            this.priceMinRangeInput.addEventListener('input', this.handlePriceMinRangeInput.bind(this));
            this.priceMaxRangeInput.addEventListener('input', this.handlePriceMaxRangeInput.bind(this));
            this.priceMinRangeInput.addEventListener('change', () => this.submitForm());
            this.priceMaxRangeInput.addEventListener('change', () => this.submitForm());

            this.priceMinNumberInput.addEventListener('change', this.handlePriceMinNumberInput.bind(this));
            this.priceMaxNumberInput.addEventListener('change', this.handlePriceMaxNumberInput.bind(this));
        }

        handlePriceMinRangeInput(){
            let minVal = Number(this.priceMinRangeInput.value);
            const maxVal = Number(this.priceMaxRangeInput.value);
            if(minVal > maxVal){
                minVal = maxVal;
                this.priceMinRangeInput.value = minVal;
            }
            this.priceMinNumberInput.value = minVal;
            this.updatePriceRangeTrack();
        }

        handlePriceMaxRangeInput(){
            const minVal = Number(this.priceMinRangeInput.value);
            let maxVal = Number(this.priceMaxRangeInput.value);
            if(maxVal < minVal){
                maxVal = minVal;
                this.priceMaxRangeInput.value = maxVal;
            }
            this.priceMaxNumberInput.value = maxVal;
            this.updatePriceRangeTrack();
        }

        handlePriceMinNumberInput(){
            let minVal = Number(this.priceMinNumberInput.value) || 0;
            let maxVal = Number(this.priceMaxNumberInput.value) || this.priceRangeMax;
            if(minVal < 0) minVal = 0;
            if(minVal > maxVal) minVal = maxVal;

            this.priceMinNumberInput.value = minVal;
            this.priceMinRangeInput.value = minVal;
            this.updatePriceRangeTrack();
            this.submitForm();
        }

        handlePriceMaxNumberInput(){
            let minVal = Number(this.priceMinNumberInput.value) || 0;
            let maxVal = Number(this.priceMaxNumberInput.value) || this.priceRangeMax;
            if(maxVal > this.priceRangeMax) maxVal = this.priceRangeMax;
            if(maxVal < minVal) maxVal = minVal;

            this.priceMaxNumberInput.value = maxVal;
            this.priceMaxRangeInput.value = maxVal;
            this.updatePriceRangeTrack();
            this.submitForm();
        }

        updatePriceRangeTrack(){
            const minVal = Number(this.priceMinRangeInput.value);
            const maxVal = Number(this.priceMaxRangeInput.value);
            const max = this.priceRangeMax;

            const leftPercent = max > 0 ? (minVal / max) * 100 : 0;
            const rightPercent = max > 0 ? (maxVal / max) * 100 : 100;

            this.priceRangeTrack.style.left = `${leftPercent}%`;
            this.priceRangeTrack.style.width = `${Math.max(rightPercent - leftPercent, 0)}%`;
        }

        submitForm(){
            // disable sideform filter
            this.sidebarFilter.setAttribute('data-disable', 'true');

            var params = new URLSearchParams();
            this.inputs.forEach(item => {
                if(item.classList.contains('checkbox')){
                    var itemId = item.getAttribute('id');
                    var itemLabel = this.sidebarFilter.querySelector('label[for="'+ itemId +'"]');
                    if(itemLabel && itemLabel.getAttribute('data-checked') == 'true') params.append(item.name, item.value);
                }else if(item.classList.contains('facet-filters__category') || item.classList.contains('facet-filters__prefecture')){
                    if(item.value !== '') params.append(item.name, item.value);
                }else if(item.classList.contains('price-range-slider__range-input')){
                    // decorative slider handles only, not real filter inputs
                }else{
                    params.append(item.name, item.value);
                }
            })

            const queryString = params.toString();
            const currentURL = this.dataset.url + '?' + queryString;

            this.loadProducts(currentURL);
            this.updateURL(currentURL);
        }

        submitFormByURL(newURL){
            // disable sideform filter
            this.sidebarFilter.setAttribute('data-disable', 'true');

            this.loadProducts(newURL, true);
            this.updateURL(newURL);
        }

        async loadProducts(currentURL, actionRemove = false, fromInputSearch = false){
            try{
                const pageRes = await fetch(
                    `${currentURL}`
                );
                const pageText = await pageRes.text();
                const pageHTML = new DOMParser().parseFromString(pageText, 'text/html');

                const productsWrapper = this.dataset.content == 'collection'?
                    pageHTML.querySelector('#collection-product-list__products-wrapper') :
                    pageHTML.querySelector('#search-item-list__items-wrapper');

                const products = this.dataset.content == 'collection'?
                    productsWrapper.querySelector('#collection-product-list__products') :
                    productsWrapper.querySelector('#search-item-list__items');

                const facetRemoveWrapper = this.dataset.content == 'collection'?
                    pageHTML.querySelector('.collection-product-list__active-tags') :
                    pageHTML.querySelector('.search-product-list__active-tags');

                const sidebarFilter = pageHTML.querySelector('sidebar-filter');

                const totalNumberOfProducts = this.dataset.content == 'collection'?
                    pageHTML.querySelector('.collection-product-list__total-number') :
                    pageHTML.querySelector('.search-product-list__total-number');

                const formFacetFilter = pageHTML.querySelector('facet-filters-form');
                
                if(productsWrapper.dataset.empty == 'true'){
                    // product is empty
                    this.products.innerHTML = '';
                    this.products.appendChild(products.querySelector('.product-list__products--empty'));

                    if(this.btnColumnSwitch) this.btnColumnSwitch.setAttribute('data-hidden', 'true');
                    if(this.facetWrapper) this.facetWrapper.setAttribute('data-hidden', 'true');
                    if(this.btnLoadMore) this.btnLoadMore.classList.add('d-none');
                }else{
                    const btnLoadMore = productsWrapper.querySelector('.btn-load-more');
                    this.products.innerHTML = '';
                    
                    // get product
                    const productCards = products.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper');
                    productCards.forEach(item => {
                        this.applyColumnClasses(item, this.btnColumnSwitch.dataset.column);
                        this.products.appendChild(item);
                    });
    
                    if(btnLoadMore && !btnLoadMore.classList.contains('d-none')){
                        if(this.btnLoadMore){
                            this.btnLoadMore.classList.remove('d-none');
                            this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                            
                            const btnLoadMoreWrapper = this.btnLoadMore.closest('pagination-button');
                            if(btnLoadMoreWrapper){
                                btnLoadMoreWrapper.classList.remove('d-none');
                                btnLoadMoreWrapper.classList.add('d-block');
                                btnLoadMoreWrapper.classList.add('pt-5');
                                btnLoadMoreWrapper.classList.add('my-5');
                            }
                        }
                    }else{
                        if(this.btnLoadMore) this.btnLoadMore.classList.add('d-none');
                    }

                    if(this.btnColumnSwitch) this.btnColumnSwitch.setAttribute('data-hidden', 'false');
                    if(this.facetWrapper) this.facetWrapper.setAttribute('data-hidden', 'false');
                }

                // update sidebar filter
                if(!actionRemove) this.updateSidebarFilterLabel(sidebarFilter);
                else{
                    if(fromInputSearch){
                        this.replaceSidebarFilter(sidebarFilter);
                        this.updateFacetFilterUrl(formFacetFilter.dataset.url);
                    }else{
                        this.updateSidebarFilter(sidebarFilter);
                    }
                }

                this.updateFacetTag(facetRemoveWrapper);
                this.updateTotalNumberItem(totalNumberOfProducts);

                // update category filter dropdown to reflect the current server state
                const categorySelectWrapper = pageHTML.querySelector('.category-select-wrapper');
                if(this.categorySelectWrapper && categorySelectWrapper){
                    this.categorySelectWrapper.innerHTML = categorySelectWrapper.innerHTML;
                    this.initCategorySelect();

                    this.inputs = this.form.querySelectorAll('input');
                    this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];
                }

                // update prefecture filter dropdown to reflect the current server state
                const prefectureSelectWrapper = pageHTML.querySelector('.prefecture-select-wrapper');
                if(this.prefectureSelectWrapper && prefectureSelectWrapper){
                    this.prefectureSelectWrapper.innerHTML = prefectureSelectWrapper.innerHTML;
                    this.initPrefectureSelect();

                    this.inputs = this.form.querySelectorAll('input');
                    this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];
                }

                // update price range slider to reflect the current server state
                const priceRangeSlider = pageHTML.querySelector('.price-range-slider');
                if(this.priceRangeSlider && priceRangeSlider){
                    this.priceRangeSlider.innerHTML = priceRangeSlider.innerHTML;
                    this.initPriceRangeSlider();

                    this.inputs = this.form.querySelectorAll('input');
                    this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];
                }
            } catch(error){
                console.error(error);
                // alert(error.message);
            } finally {
                if(this.btnLoadMore) this.btnLoadMore.setAttribute('data-disabled', 'false');
                this.sidebarFilter.setAttribute('data-disable', 'false');
            }
        }

        updateFacetFilterUrl(url){
            this.dataset.url = url;
        }

        applyColumnClasses(item, columnValue){
            item.classList.remove('col-xl-2', 'col-xl-3', 'col-xl-4', 'col-6', 'col-12');

            if(columnValue == '3'){
                item.classList.add('col-xl-4', 'col-12');
            }else if(columnValue == '6'){
                item.classList.add('col-xl-2', 'col-6');
            }else{
                item.classList.add('col-xl-3', 'col-6');
            }
        }

        updateURL(currentURL){
            window.history.replaceState({ }, '', `${currentURL}`);
        }

        updateSidebarFilterLabel(sidebarFilter){
            const labels = sidebarFilter.querySelectorAll('.facet__elem-label');
            const currentLabels = this.sidebarFilter.querySelectorAll('.facet__elem-label');
            labels.forEach((item, index)=> {
                var labelText = item.innerHTML;
                currentLabels[index].innerHTML = labelText;
            })
        }

        updateTotalNumberItem(totalNumberOfProducts){
            if(this.totalNumberOfProducts)
                this.totalNumberOfProducts.innerHTML = totalNumberOfProducts.innerHTML;
        }

        updateSidebarFilter(sidebarFilter){
            const currentElem = this.sidebarFilter.querySelectorAll('.facet__elem');
            const elem = sidebarFilter.querySelectorAll('.facet__elem');

            currentElem.forEach((item, idx) => {
                item.innerHTML = elem[idx].innerHTML;
            })

            // update price
            if(this.sidebarFilter.querySelector('.facet__price')){
                this.sidebarFilter.querySelector('.facet__price').innerHTML = sidebarFilter.querySelector('.facet__price').innerHTML;
            }

            // update inputs
            this.inputs = this.form.querySelectorAll('input');
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

            // re-initialize sidefilter after replacing elements
            this.sidebarFilter.init();
        }

        replaceSidebarFilter(sidebarFilter){
            this.sidebarFilter.innerHTML = sidebarFilter.innerHTML;

            // re-initialize sidefilter after replacing the content
            this.sidebarFilter.init();

            // update inputs
            this.inputs = this.form.querySelectorAll('input');

            // add facets filter sidebar inputs to this.inputs
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

        }

        updateFacetTag(facetRemoveWrapper){
            this.facetRemoveWrapper.innerHTML = facetRemoveWrapper.innerHTML;
            this.facetRemoveWrapper.setAttribute('data-hidden', facetRemoveWrapper.getAttribute('data-hidden'));
        }
    }

    customElements.define('facet-filters-form', FacetFiltersForm);
}

if(!customElements.get('sidebar-filter')){
    class SidebarFilter extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.facetForm = document.querySelector('facet-filters-form');

            this.btnClose = this.querySelector('.btn-close');
            this.btnClose.addEventListener('click', e => {
                this.setAttribute('data-hidden', 'true');
                document.querySelector('html').style.overflow = 'initial';

                if(this.previouslyFocusedElement){
                    this.previouslyFocusedElement.focus();
                }
            });
            this.addEventListener('keydown', (event) => {
                if(event.key === 'Escape'){
                    this.setAttribute('data-hidden', 'true');
                    document.querySelector('html').style.overflow = 'initial';

                    if(this.previouslyFocusedElement){
                        this.previouslyFocusedElement.focus();
                    }
                }
            })

            this.addEventListener('click', e => {
                if(e.target.nodeName == 'SIDEBAR-FILTER'){
                    this.setAttribute('data-hidden', 'true');
                    document.querySelector('html').style.overflow = 'initial';

                    if(this.previouslyFocusedElement){
                        this.previouslyFocusedElement.focus();
                    }
                }
            })

            this.inputWrappers = this.querySelectorAll('.input-wrapper');
            this.inputs = this.querySelectorAll('.input-wrapper input');
            this.inputs.forEach(item => {
                item.addEventListener('focus', this.focusOnInput.bind(this));
                item.addEventListener('focusout', this.focusOutOnInput.bind(this));
                item.addEventListener('change', this.updateInput.bind(this));
            });

            this.checkboxs = this.querySelectorAll('input[type="checkbox"]');
            this.labels = [];
            this.checkboxs.forEach(item => {
                item.disabled = false;
                item.checked =false;

                var label = this.querySelector('label[for="'+ item.getAttribute('id')+'"]');
                this.labels.push(label);
                label.addEventListener('click', e => {
                    this.clickOnFilterValue(e.currentTarget);
                });
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.clickOnFilterValue(label);
                    }
                })
            });

            this.btnClear = this.querySelector('.sidebar__filter-btn-clear');
            this.btnClear.addEventListener('click', this.clearAllFilter.bind(this));
            this.btnClear.addEventListener('keydown', (event) => {
                if(event.key === 'Enter'){
                    this.clearAllFilter();
                }
            })

            this.btnDone = this.querySelector('.slidebar__filter-btn-done');
            this.btnDone.addEventListener('click', e => {
                this.setAttribute('data-hidden', 'true');
                document.querySelector('html').style.overflow = 'initial';

                if(this.previouslyFocusedElement){
                    this.previouslyFocusedElement.focus();
                }
            })
        }

        refresh(){
            this.init();
        }

        openSidebarFilter(){
            this.previouslyFocusedElement = document.activeElement;
            
            this.setAttribute('data-hidden', 'false');
            document.querySelector('html').style.overflow = 'hidden';

            let index = 0;
            const focusElem = setInterval(() => {
                // make accordion focusable
                var firstItem = this.querySelectorAll('.accordion-heading')[0];
                firstItem.focus();

                var focusedElement = document.activeElement;

                index++;
                if(focusedElement === firstItem || index > 5) clearInterval(focusElem);
            }, 100);

            this.accordions = this.querySelectorAll('custom-accordion');
            this.accordions.forEach((item, index) => {
                item.addEventListener('keydown', (event) => {
                    if(event.key === 'Tab'){
                        // check if current accordion is open, if so focus on the next element, otherwise, move to next one
                        if(item.getAttribute('data-open') === 'false'){
                            if(this.accordions[index + 1]){
                                const focusElem = setInterval(() => {
                                    let activeItem = this.accordions[index + 1];
                                    activeItem.focus();
                                    let focusedElement = document.activeElement;

                                    index++;
                                    if(focusedElement === activeItem || index > 5) clearInterval(focusElem);
                                }, 100);
                            }
                        }
                    }
                })
            })
        }

        clearAllFilter(){
            // remove all checkbox selection
            this.checkboxs.forEach(item => {
                item.removeAttribute('checked');
                var label = this.querySelector('label[for="'+ item.getAttribute('id') +'"]');
                label.setAttribute('data-checked', 'false');
            })

            // remove all price range
            this.querySelectorAll('input[type="number"]').forEach(item => {
                item.value = '';
            });
            this.focusOutOnInput();

            this.facetForm.submitForm();
        }

        clickOnFilterValue(label){
            var checkboxWrapper = label.closest('.facet__elem');
            var checkbox = checkboxWrapper.querySelector('input[type="checkbox"]');

            if(label.getAttribute('data-checked') != 'true'){
                label.setAttribute('data-checked', 'true');
                checkbox.setAttribute('checked', 'checked');

                this.facetForm.submitForm();

                return;
            }

            label.setAttribute('data-checked', 'false');
            label.getAttribute('data-checked')
            checkbox.removeAttribute('checked');

            this.facetForm.submitForm();
        }

        focusOnInput(e){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })

            var currentTarget = e.currentTarget;
            var currentTargetInputWrapper = currentTarget.closest('.input-wrapper');
            currentTargetInputWrapper.setAttribute('data-selected', 'true');
        }

        focusOutOnInput(){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })
        }

        updateInput(e){
            this.facetForm.submitForm();
        }
    }

    customElements.define('sidebar-filter', SidebarFilter);
}

if(!customElements.get('facet-remove')){
    class FacetRemove extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.productList = this.closest('custom-collection-product-list')? this.closest('custom-collection-product-list') : this.closest('custom-search-product-list');
            this.facetFiltersForm = this.productList.querySelector('facet-filters-form');
            this.form = this.productList.querySelector('#FacetForm');
            
            this.inputs = this.form.querySelectorAll('input');
            
            // add facets filter sidebar inputs to this.inputs
            this.sidebarFilter = document.querySelector('sidebar-filter');
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

            this.link = this.querySelector('a');
            this.link.addEventListener('click', this.removeFacet.bind(this));
        }

        refresh(){
            this.init();
        }

        removeFacet(e){
            e.preventDefault();

            var href = this.link.getAttribute('href');
            this.facetFiltersForm.submitFormByURL(href);

            this.setAttribute('data-hidden', 'true');
        }
    }

    customElements.define('facet-remove', FacetRemove);
}